<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-dialog
      v-model="cropImageDialog"
      persistent
      :width="
        $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'
          ? '100vw'
          : $vuetify.breakpoint.name == 'md'
          ? '80vw'
          : $vuetify.breakpoint.name == 'lg'
          ? '50vw'
          : '40vw'
      "
    >
      <v-card>
        <v-layout wrap justify-center pa-2>
          <v-flex xs12>
            <ImageCropper
              :image="currentImage"
              :key="currentImage"
              @stepper="imageCropper"
            />
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout wrap justify-start pt-4 px-2 px-lg-0 pl-lg-12 pl-xl-12>
      <v-flex xs12 py-4>
        <v-layout pt-3 wrap justify-start>
          <v-flex xs7 sm3 md3 lg2 xl2>
            <v-layout wrap justify-center>
              <!-- <v-flex xs3 sm2 text-left align-self-center>
                <v-img
                  src="./../../../assets/icon.png"
                  contain
                  height="15px"
                ></v-img>
              </v-flex> -->
              <v-flex xs9 sm10 text-left pl-2 align-self-center>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 18px;
                    color: #1c1c1c;
                  "
                >
                  Edit Product
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- Main Container -->
      <v-flex xs12 md12 lg7 xl7>
        <v-layout wrap justify-start>
          <v-flex xs12 sm4 md4 lg4 xl4 pr-sm-2 text-left>
            <span class="styloopinputlabel"> Select item type </span>
            <v-select
              outlined
              dense
              color="#FF1313"
              placeholder="Sub-category"
              v-model="product.subcategory"
              :items="subcategoryArray"
              item-text="name"
              item-value="_id"
              item-color="#FF1313"
              hide-details
              v-on:input="subSize(product.subcategory)"
              class="text-left"
            >
              <template v-slot:item="{ item }">
                <span class="text-left">
                  {{ item.name }}
                </span>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs12 sm8 md8 lg8 xl8 pl-sm-2 text-left>
            <span class="styloopinputlabel"> Select Category type </span>
            <v-select
              outlined
              small-chips
              deletable-chips
              dense
              multiple
              v-model="product.category"
              color="#FF1313"
              placeholder="Category"
              :items="categoryArray"
              item-text="name"
              item-value="_id"
              item-color="#FF1313"
              hide-details
            >
            </v-select>
          </v-flex>
          <v-flex xs12 sm4 md4 lg4 xl4 pr-sm-2 text-left>
            <span class="styloopinputlabel"> Product Unique Id </span>
            <v-text-field
              v-model="product.productcode"
              color="#FF1313"
              hide-selected
              outlined
              placeholder="Product Unique Id"
              dense
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm8 md8 lg8 xl8 pl-sm-2 text-left>
            <span class="styloopinputlabel"> Pincode </span>
            <v-select
              outlined
              small-chips
              deletable-chips
              dense
              multiple
              v-model="product.pincodeGroup"
              color="#FF1313"
              placeholder="Regions"
              :items="pincodeArray"
              item-text="name"
              item-value="_id"
              item-color="#FF1313"
              hide-details
            >
            </v-select>
          </v-flex>
          <v-flex xs12 text-left>
            <span class="styloopinputlabel"> Name of the Product </span>
            <v-text-field
              v-model="product.productname"
              color="#FF1313"
              hide-selected
              outlined
              placeholder="Name of the product"
              dense
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 text-left>
            <span class="styloopinputlabel"> Caption of the Product </span>
            <v-textarea
              rows="2"
              v-model="product.caption"
              color="#FF1313"
              hide-selected
              outlined
              placeholder="Enter a few words about the product"
              dense
              counter
              maxlength="100"
            ></v-textarea>
          </v-flex>
          <v-flex xs12 text-left>
            <span class="styloopinputlabel"> Description of the Product </span>
            <v-textarea
              rows="3"
              v-model="product.description"
              color="#FF1313"
              hide-selected
              hide-details=""
              outlined
              placeholder="Describe the product"
              dense
              counter
            ></v-textarea>
          </v-flex>
          <v-flex xs12 text-left pt-2>
            <span class="styloopinputlabel">Add Description</span>
            <v-combobox
              placeholder="Description Tags"
              v-model="product.tags"
              outlined
              color="#FF1313"
              multiple
              dense
              hide-details
              small-chips
            >
              <template v-slot:selection="{ attrs, item, parent, selected }">
                <span class="pa-1">
                  <v-chip v-bind="attrs" :input-value="selected" small>
                    <span
                      class="pr-2"
                      style="font-family: opensansregular; font-size: 13px"
                    >
                      {{ item }}
                    </span>
                    <v-icon small @click="parent.selectItem(item)">
                      mdi-close-circle
                    </v-icon>
                  </v-chip>
                </span>
              </template>
              <template v-slot:append>
                <span></span>
              </template>
            </v-combobox>
          </v-flex>
          <v-flex xs12 text-left pt-2>
            <span class="styloopinputlabel">Material Used</span>
            <v-combobox
              placeholder="Tags"
              v-model="product.materialused"
              outlined
              color="#FF1313"
              multiple
              dense
              hide-details
              small-chips
            >
              <template v-slot:selection="{ attrs, item, parent, selected }">
                <span class="pa-1">
                  <v-chip v-bind="attrs" :input-value="selected" small>
                    <span
                      class="pr-2"
                      style="font-family: opensansregular; font-size: 13px"
                    >
                      {{ item }}
                    </span>
                    <v-icon small @click="parent.selectItem(item)">
                      mdi-close-circle
                    </v-icon>
                  </v-chip>
                </span>
              </template>
              <template v-slot:append>
                <span></span>
              </template>
            </v-combobox>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- Image Container -->
      <v-flex xs12 md12 lg4 xl3 pl-sm-4 pt-2>
        <v-layout wrap justify-center>
          <v-flex pt-4 xs12 text-left>
            <v-layout wrap justify-center>
              <v-flex xs8 sm6 md6 lg8>
                <v-card flat tile outlined height="300px">
                  <v-layout wrap justify-center fill-height>
                    <v-flex md12 lg12 align-self-center>
                      <v-img
                        v-if="product.photos[0] || imageArray.length > 0"
                        :src="
                          product.photos[0]
                            ? mediaURL + product.photos[0]
                            : imageArray[0]
                        "
                        height="298px"
                        contain
                      >
                        <v-layout wrap>
                          <v-flex text-right pa-2>
                            <v-avatar color="#FF3434" size="20">
                              <v-icon
                                color="#FFF"
                                small
                                @click="
                                  product.photos[0]
                                    ? removePhoto(0)
                                    : removeImageArray(0)
                                "
                              >
                                mdi-close
                              </v-icon>
                            </v-avatar>
                          </v-flex>
                        </v-layout>
                      </v-img>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs4 sm3 md3 lg4>
                <v-layout pt-0 wrap justify-center>
                  <v-flex
                    xs12
                    v-for="(item, i) in product.photos"
                    :key="i"
                    pa-1
                  >
                    <v-img
                      v-if="i > 0"
                      :src="mediaURL + item"
                      height="85px"
                      contain
                    >
                      <v-layout wrap>
                        <v-flex text-right pa-0>
                          <v-avatar color="#FF3434" size="15">
                            <v-icon color="#FFF" small @click="removePhoto(i)">
                              mdi-close
                            </v-icon>
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                    </v-img>
                  </v-flex>
                  <v-flex xs12 v-for="(item, i) in imageArray" :key="i" pa-1>
                    <v-img :src="item" height="85px" contain>
                      <v-layout wrap>
                        <v-flex text-right pa-0>
                          <v-avatar color="#FF3434" size="15">
                            <v-icon
                              color="#FFF"
                              small
                              @click="removeImageArray(i)"
                            >
                              mdi-close
                            </v-icon>
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                    </v-img>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm9 md9 lg12 pt-4 text-left>
            <v-btn
              width="180px"
              small
              tile
              depressed
              :ripple="false"
              class="text-capitalize"
              color="#EFEFEF"
              @click="$refs.files.click()"
            >
              <v-layout wrap justify-center>
                <v-flex xs8 text-right>
                  <span style="font-size: 12px; font-family: opensanssemibold">
                    Upload Image
                  </span>
                </v-flex>
                <v-flex xs4 text-right>
                  <v-img
                    src="./../../../assets/icons/file-upload.svg"
                    height="15px"
                    contain
                  ></v-img>
                </v-flex>
              </v-layout>
            </v-btn>
            <input
              v-show="false"
              accept="image/*"
              id="file"
              ref="files"
              multiple="multiple"
              type="file"
              @change="uploadImages"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- Product Stock -->
      <v-flex xs12 md12 lg10 xl7>
        <v-layout wrap justify-center>
          <v-flex xs12 text-left>
            <span class="styloopinputlabel">Product Stock</span>
          </v-flex>
          <v-flex xs12>
            <StockAdder
              v-bind:storage="subSizeArray"
              v-bind:sizeData="product.size"
              :key="subSizeArray[0]"
              @stepper="winStepper"
            />
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 md12 lg7 xl7>
        <v-layout pt-2 wrap>
          <v-flex sm3 md3 lg3 xl3 text-left>
            <span class="styloopinputlabel"> Total Stock </span>
            <v-text-field
              disabled
              type="number"
              placeholder="Stock"
              v-model="product.stockquantity"
              outlined
              color="#FF1313"
              hide-details
              dense
            ></v-text-field>
          </v-flex>
          <v-flex pl-sm-2 sm3 md3 lg3 xl3 text-left>
            <span class="styloopinputlabel">Price </span>
            <v-text-field
              placeholder="Price"
              style="max-height: 46px !important"
              type="number"
              v-model="product.productcost"
              outlined
              color="#FF1313"
              hide-details
              dense
            ></v-text-field>
          </v-flex>
          <!-- <v-flex pl-sm-2 sm3 md3 lg3 xl3 text-left>
            <span class="styloopinputlabel">Markup Price</span>
            <v-text-field
              placeholder="Markup Price"
              type="number"
              v-model="product.profitmargin"
              outlined
              color="#FF1313"
              hide-details
              dense
            ></v-text-field>
          </v-flex> -->
          <v-flex pl-sm-2 sm3 md3 lg3 xl3 text-left>
            <span class="styloopinputlabel">Total Price</span>
            <v-text-field
              placeholder="Total Price"
              type="number"
              v-model="product.price"
              outlined
              color="#FF1313"
              dense
              hide-details
              readonly
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout wrap py-3>
          <v-flex text-left xs12 lg12>
            <PriceDistro
              v-bind:productcost="product.productcost"
              v-bind:subcategoryData="singleSubcatData"
              :key="product.price"
              @stepper="priceChanger"
            />
          </v-flex>
        </v-layout>

        <!-- Text-input -->
      </v-flex>
      <v-flex md12 lg7 pb-3 py-4 text-right hidden-sm-and-down>
        <span class="px-2">
          <v-btn
            width="250px"
            outlined
            tile
            color="#757575"
            dark
            :ripple="false"
            depressed
            @click="$router.go(-1)"
          >
            <span
              style="
                font-family: kumbhsansregular;
                font-size: 16px;
                text-transform: none;
                color: #000000;
              "
            >
              Cancel
            </span>
          </v-btn>
        </span>
        <span class="px-2">
          <v-btn
            width="250px"
            tile
            dark
            color="#FF1313"
            depressed
            class="text-capitalize"
            :ripple="false"
            @click="editProduct()"
          >
            Apply
          </v-btn>
        </span>
      </v-flex>
      <v-flex xs6 py-4 px-2 text-right hidden-md-and-up>
        <v-btn
          block
          outlined
          tile
          color="#757575"
          dark
          :ripple="false"
          depressed
          @click="$router.go(-1)"
        >
          <span
            style="
              font-family: kumbhsansregular;
              font-size: 16px;
              text-transform: none;
              color: #000000;
            "
          >
            Cancel
          </span>
        </v-btn>
      </v-flex>
      <v-flex xs6 py-4 px-2 hidden-md-and-up>
        <v-btn
          block
          tile
          dark
          color="#FF1313"
          depressed
          class="text-capitalize"
          :ripple="false"
          @click="editProduct()"
        >
          Apply
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import StockAdder from "./stockAdder";
import PriceDistro from "./priceDistro";
import ImageCropper from "./../../Common/imageCropper";
import axios from "axios";
export default {
  props: ["id"],
  components: {
    StockAdder,
    PriceDistro,
    ImageCropper,
  },
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: null,
      ServerError: false,
      showSnackBar: false,
      imageArray: [],
      Images: new FormData(),
      formData: new FormData(),
      selectedFiles: null,
      image: null,
      pincodeArray: [],
      subSizeArray: [],
      productStock: {},
      product: {
        productcode: null,
        subcategory: null,
        category: [],
        pincodeGroup: [],
        photos: [],
        productname: null,
        caption: null,
        description: null,
        stockquantity: null,
        productcost: null,
        // profitmargin: null,
        price: null,
        instock: false,
        unit: "Count",
        tags: [],
        materialused: [],
        size: [],
      },
      rules: {
        required: (value) => !!value || "Required.",
      },
      imageCount: 0,
      cropImageDialog: false,
      currentImage: null,
      singleSubcatData: {},
    };
  },
  computed: {
    categoryArray() {
      var arr = [];
      arr = this.$store.state.categories.data;
      arr = arr.splice(0, 2);
      return arr;
    },
    subcategoryArray() {
      return this.$store.state.subCategories;
    },
  },
  beforeMount() {
    this.$store.dispatch("getCategory");
    this.$store.dispatch("getSubCategory");
    this.getData();
    this.getPincodes();
  },
  methods: {
    imageCropper(payload) {
      this.cropImageDialog = payload.dialog;
      if (payload.image) {
        this.collectImages(payload.image);
      }
    },
    priceChanger(window_data) {
      this.product.price = window_data.price;
    },
    winStepper(window_data) {
      this.productStock = window_data.productStock;
      this.product.size = this.productStock;
      this.product.stockquantity = 0;
      for (var i = 0; i < this.productStock.length; i++) {
        for (var j = 0; j < this.productStock[i].stock.length; j++) {
          this.product.stockquantity =
            this.product.stockquantity + this.productStock[i].stock[j].stock;
        }
      }
    },
    subSize(id) {
      for (var i = 0; i < this.subcategoryArray.length; i++) {
        if (id == this.subcategoryArray[i]._id) {
          this.subSizeArray = this.subcategoryArray[i].size;
          this.singleSubcatData = this.subcategoryArray[i];
        }
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/product/info",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.product = response.data.data;
            this.subSize(this.product.subcategory._id);
            this.imageCount =
              this.product.photos.length + this.imageArray.length;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    getPincodes() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/pincode/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.pincodeArray = response.data.data;
              this.appLoading = false;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    uploadImages(event) {
      if (this.imageCount < 4) {
        this.currentImage = URL.createObjectURL(event.target.files[0]);
        this.cropImageDialog = true;
      } else {
        this.msg = "Maximum image limit exceeded!";
        this.showSnackBar = true;
        return;
      }
    },

    collectImages(image) {
      this.selectedFiles = image;
      this.Images.append("image", this.selectedFiles);
      this.formData.append("photos", this.selectedFiles);
      var img = new Image();
      img.src = window.URL.createObjectURL(image);
      img.onload = () => {
        const urls = URL.createObjectURL(image);
        this.imageArray.push(urls);
        this.imageCount = this.product.photos.length + this.imageArray.length;
        if (this.imageArray) {
          this.image = this.imageArray[0];
        }
      };
    },
    removeImageArray(i) {
      var values = this.formData.getAll("photos");
      values.splice(i, 1);
      this.formData.set("photos", values);
      this.imageArray.splice(i, 1);
    },
    removePhoto(i) {
      var Data = {};
      this.product.photos.splice(i, 1);
      Data["productid"] = this.product._id;
      Data["position"] = i + 1;
      axios({
        method: "POST",
        url: "/Product/RemoveImagesingle",
        data: Data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.imageCount =
              this.product.photos.length + this.imageArray.length;
            this.showSnackBar = true;
            this.msg = "Deleted Successfully";
          } else {
            this.msg = "Can't Delete Image";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    editProduct() {
      this.appLoading = true;
      this.product.id = this.product._id;
      // this.product.profitmargin = parseFloat(this.product.profitmargin);
      this.product.productcost = parseFloat(this.product.productcost);
      this.product.price = parseFloat(this.product.price);
      this.product.stockquantity = Number(this.product.stockquantity);
      if (this.product.stockquantity > 0) this.product.instock = true;

      axios({
        method: "POST",
        url: "/product/Edit",
        data: this.product,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            if (this.imageArray.length > 0) {
              this.uploadAllImages(response.data.product._id);
            } else {
              this.$router.push(
                "/Seller/Product/Edited/" + response.data.product._id
              );
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    uploadAllImages(item) {
      this.formData.append("productid", item);
      axios({
        method: "POST",
        url: "/Product/UploadImageMultiple",
        data: this.formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.$router.push("/Seller/Product/Edited/" + item);
          } else {
            this.msg = "Can't Upload Images";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style  scoped>
.v-input__slot {
  min-height: 36px;
}
.v-select > .dropdown-menu {
  text-align: right;
}
</style>